export const TENANT_USER_ACCOUNT_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
  { value: "Pending", label: "Pending" },
  { value: "Marked for delete", label: "Marked for delete" },
] as const;

export const TENANT_USER_ACCOUNT_STATUS_TEXT_CLASS_MAP: Record<string, string> =
  {
    Active: "text-[#28A745]",
    Inactive: "text-[#555555]",
    Pending: "text-[#F59E0B]",
    "Marked for delete": "text-[#DC3545]",
  };
